export const INFINITY_CHARACTER = "∞";
export const NEGATIVE_INFINITY_CHARACTER = "-∞";

export const coerceIfInfinity = (
  value: number | string,
  infinityAsCharacter?: boolean
) => {
  const coercedValue =
    value === Number.MAX_VALUE ||
    (typeof value === "string" && value.toLowerCase() === "infinity")
      ? Infinity
      : value === -Number.MAX_VALUE ||
          (typeof value === "string" && value.toLowerCase() === "-infinity")
        ? -Infinity
        : value;

  return infinityAsCharacter
    ? coercedValue === Infinity
      ? INFINITY_CHARACTER
      : coercedValue === -Infinity
        ? NEGATIVE_INFINITY_CHARACTER
        : coercedValue
    : coercedValue;
};

export function getDecimalPlaces(value: number): number {
  const valueStr = String(value);
  if (valueStr.indexOf("e") >= 0) {
    const [val, exp] = valueStr.split("e");
    return Math.max(getDecimalPlaces(Number(val)) - Number(exp), 0);
  } else {
    return valueStr.split(".")[1]?.length || 0;
  }
}

export function decimalToPercent(value: number) {
  const decimalPlaces = getDecimalPlaces(value);
  return Number((value * 100).toFixed(Math.max(decimalPlaces - 2, 0)));
}

export function percentToDecimal(value: number) {
  const decimalPlaces = getDecimalPlaces(value);
  return Number((value / 100).toFixed(decimalPlaces + 2));
}
